import { render, staticRenderFns } from "./SpousalSupportDetails.vue?vue&type=template&id=36c6a6d4"
import script from "./SpousalSupportDetails.vue?vue&type=script&lang=js"
export * from "./SpousalSupportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports